import { render, staticRenderFns } from "./MgrupajeequipamientoModals.vue?vue&type=template&id=bb7f2bfe"
import script from "./MgrupajeequipamientoModals.vue?vue&type=script&lang=js"
export * from "./MgrupajeequipamientoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports